import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel from 'volta/models/base-model';
import { getDisplayName, getFullName } from './user';

export default class UserProfile extends BaseModel {
  /**
   * Attributes
   */

  @attr('string') login!: string;
  @attr('string') firstName?: string;
  @attr('string') middleName?: string;
  @attr('string') lastName?: string;
  @attr('string') email?: string;
  @attr('boolean', { defaultValue: false }) connected!: boolean;
  @attr('boolean', { defaultValue: true }) isActive!: boolean;

  /**
   * Getters
   */

  get userId() {
    return this.id;
  }

  get fullName() {
    return getFullName(this);
  }

  get displayName() {
    return getDisplayName(this);
  }

  get isInactive() {
    return !this.isActive;
  }

  [Type] = 'user-profile' as const;
}
